import { Link } from 'react-router-dom';
import { company } from '../../data/company';

interface LogoProps {
  /** Use light text/marks for dark backgrounds. */
  variant?: 'default' | 'light';
  showText?: boolean;
  className?: string;
}

/**
 * The Daxesh mark — the gold swirl from the official logo, extracted as
 * vector paths so it scales cleanly. The gold reads on both light and
 * dark backgrounds.
 */
export function LogoMark({ className = 'h-9 w-9' }: { className?: string }) {
  return (
    <svg viewBox="247.4 224.36 100 98.5" className={className} aria-hidden="true">
      <path
        fillRule="evenodd"
        fill="#CFAC70"
        d="M 310.207 227.519 C 335.917 234.410 351.265 260.992 344.378 286.703 C 337.488 312.414 310.906 327.761 285.195 320.871 C 276.902 319.394 267.597 313.367 263.824 308.695 C 271.375 314.925 284.187 316.910 290.550 315.621 C 304.734 312.742 316.832 302.117 320.820 287.230 C 326.429 266.289 313.929 244.636 292.988 239.027 C 280.460 235.667 262.031 240.335 253.753 254.078 C 257.335 245.515 266.230 237.082 271.281 233.781 C 282.394 226.523 296.425 223.828 310.207 227.519"
      />
      <path
        fillRule="evenodd"
        fill="#CFAC70"
        d="M 253.574 296.328 C 248.578 288.441 247.296 278.609 249.597 268.746 C 252.160 257.742 260.277 248.828 271.199 244.710 C 271.847 244.468 272.507 244.25 273.179 244.058 C 275.226 243.472 277.359 243.062 279.437 242.781 C 284.769 242.050 291.199 242.609 296.507 244.875 C 297.75 245.402 298.992 245.867 300.085 246.484 C 300.773 246.871 300.546 247.585 300.035 247.445 C 296.578 246.484 294 246.25 291.046 246.519 C 288.785 246.726 286.906 247.652 284.820 249.078 C 280.156 252.257 277.117 257.742 277.230 263.296 C 277.339 268.710 280.082 273.039 282.785 277.578 C 285.488 282.113 288.847 286.476 288.437 291.882 C 287.902 298.910 284.070 304.019 278.890 306.402 C 268.871 311.011 258.859 304.671 253.574 296.328"
      />
    </svg>
  );
}

export default function Logo({ variant = 'default', showText = true, className = '' }: LogoProps) {
  const light = variant === 'light';
  return (
    <Link to="/" className={`group inline-flex items-center gap-3 ${className}`} aria-label={`${company.legalName} home`}>
      <LogoMark />
      {showText && (
        <span className="flex flex-col leading-none">
          <span
            className={`text-xl font-extrabold tracking-[0.18em] ${light ? 'text-white' : 'text-primary'}`}
          >
            DAXESH
          </span>
          <span
            className={`mt-0.5 text-[0.6rem] font-semibold tracking-[0.22em] ${
              light ? 'text-secondary' : 'text-secondary-dark'
            }`}
          >
            PETROCHEM PVT. LTD.
          </span>
        </span>
      )}
    </Link>
  );
}
